import resetDoneProperties from "./on-step-status/reset-done-properties";

/**
 * Reset properties on iteration
 * @param {MainClassProps} main
 * @param {TriggerProps} trigger
 * @param {TimelineMapProps} timeline
 */
const resetTimelineProperties = (main, trigger, timeline) => {
  const steps = /** @type {Array<StepProps>} */ (timeline.get("steps"));

  for (const step of steps.values()) {
    resetDoneProperties(main, trigger, timeline, step, true);
  }
};

export default resetTimelineProperties;
